module.exports = __webpack_public_path__ + "img/mme-schachtel.8d50902f.png";